/**
 * VueLayers
 * Web map Vue components with the power of OpenLayers
 *
 * @package vuelayers
 * @author Vladimir Vershinin <ghettovoice@gmail.com>
 * @version 0.11.37
 * @license MIT
 * @copyright (c) 2017-2021, Vladimir Vershinin <ghettovoice@gmail.com>
 */
import _typeof from '@babel/runtime-corejs3/helpers/esm/typeof';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';
import mergeDescriptors from 'merge-descriptors';

/**
 * @param {...Object} args
 * @returns {Object}
 */

function multiMergeDescriptors() {
  var redefine;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (_typeof(args[args.length - 1]) !== 'object') {
    redefine = args.pop();
  }

  return _sliceInstanceProperty(args).call(args, 1).reduce(function (dest, src, i) {
    return mergeDescriptors(dest, src, redefine);
  }, args[0]);
}

export default multiMergeDescriptors;
